module.exports = __webpack_public_path__ + "static/screenshot-54deba24272ae3a9349001bab64070fd.png";